<template>
    <div class="allchain">
        <leftnav class="fl" mkcode="J" :itemcode="yj_itemcode"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <span class="title" v-show="userdata.city>0" @click="routerself('/hometownInvestment?type=1')">本市乡贤</span> 
                        <span class="title" @click="routerself('/hometownInvestment?type=2')">本省乡贤</span> 
                        <span class="title current">广东企业库</span> 
                        
                    </div>
                    <el-form :model="landSearchFilter" ref="projectForm" label-position="left"
                        class="employer-ruleForm mt-2">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label=" 区域" prop="area" :label-width="labelWidth">
                                    <el-select class="seletc-size-input" v-model="landSearchFilter.province" :disabled = "true"
                                        placeholder="请选择" @change="onProvinceChange('province', $event)">
                                        <el-option value="" label="全部"></el-option>
                                        <el-option v-for="(item) in provinceList" :key="item.areaId"
                                            :value="item.areaId" :label="item.areaName"></el-option>
                                    </el-select>
                                    <el-select class="seletc-size-input" v-model="landSearchFilter.city"
                                        placeholder="请选择" @change="onProvinceChange('city', $event)"
                                        :disabled="landSearchFilter.province == ''">
                                        <el-option value="" label="全部"></el-option>
                                        <el-option v-for="(item, index) in cityList" :key="index" :value="item.areaId"
                                            :label="item.areaName"></el-option>
                                    </el-select>
                                    <el-select class="seletc-size-input" v-model="landSearchFilter.district"
                                        placeholder="请选择" @change="onProvinceChange('county', $event)"
                                        :disabled="landSearchFilter.city == ''">
                                        <el-option value="" label="全部"></el-option>
                                        <el-option v-for="(item, index) in countyList" :key="index" :value="item.areaId"
                                            :label="item.areaName"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode" :label-width="labelWidth">
                                    <el-input class="text-input" v-model="landSearchFilter.unifiedSocialCreditCode"
                                        placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="成立日期" prop="date1" :label-width="labelWidth">
                                    <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="large"
                                        v-model="landSearchFilter.establishmentDateMin" type="date"
                                        placeholder="选择开始时间"></el-date-picker> -
                                    <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                        v-model="landSearchFilter.establishmentDateMax" type="date"
                                        placeholder="选择结束时间"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="注册资本" prop="registeredCapitalMin" :label-width="labelWidth">
                                    <el-input class="num-size-input" v-model="landSearchFilter.registeredCapitalMin"
                                        placeholder=""></el-input>
                                    -
                                    <el-input class="num-size-input" v-model="landSearchFilter.registeredCapitalMax"
                                        placeholder=""></el-input>
                                    （万元）
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="企业名称" prop="enterpriseName" :label-width="labelWidth">
                                    <el-input class="text-input" v-model="landSearchFilter.enterpriseName"
                                        placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系电话" prop="contactPhone" :label-width="labelWidth">
                                    <el-input class="text-input" v-model="landSearchFilter.contactPhone"
                                        placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="12">
                                <el-form-item label="实收资本" prop="actualCapitalMin" :label-width="labelWidth">
                                    <el-input class="num-size-input" v-model="landSearchFilter.actualCapitalMin"
                                        placeholder=""></el-input>
                                    -
                                    <el-input class="num-size-input" v-model="landSearchFilter.actualCapitalMax"
                                        placeholder=""></el-input>
                                    （万元）
                                </el-form-item>
                            </el-col> -->
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="地址" prop="address" :label-width="labelWidth">
                                    <el-input class="text-input" v-model="landSearchFilter.address"
                                        placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="法定代表人" prop="legalRepresentative" :label-width="labelWidth">
                                    <el-input class="text-input" v-model="landSearchFilter.legalRepresentative"
                                        placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="行业" prop="industry" :label-width="labelWidth">
                                   <el-select class="seletc-size-input-1" v-model="landSearchFilter.industry" placeholder="请选择" size="large">
                                        <el-option v-for="item in industryList" :key="item.value"
                                            :value="item.value" :label="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="btn oh mr-8 mb-2">
                        <div class="fr">
                            <el-button icon="el-icon-search" type="primary" @click="ajaxsearchcompany(1)">查询</el-button>
                            <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
                        </div>
                    </div>
                </div>
                <div class="whitebox">
                    <div class="pb-3 pt-2">
                        <table border="0" cellspacing="0" cellpadding="0" class="land_table">
                            <tr>
                                <th>序号</th>
                                <th>企业名称</th>
                                <th>行业</th>
                                <th>注册资本（万元）</th>
                                <th>法定代表人</th>
                                <th>联系电话</th>
                            </tr>
                            <tr v-for="(item, index) in enterpristlist" :key="index">
                                <td class="text-center">{{ (page - 1) * pageSize + index + 1 }}</td>
                                <td class="cur-pointer basefont"
                                    @click="gdEenterpriseDetail('/gdEenterpriseDetail?id=' + item.id)">{{
                                    item.enterpriseName || '-' }}</td>
                                <td>{{ item.industry || '-' }}</td>
                                <td>{{ item.registeredCapital}}</td>
                                <td>{{ item.legalRepresentative || '-' }}</td>
                                <td>{{ item.contactPhone || '-' }}</td>


                            </tr>
                        </table>
                    </div>
                    <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
                        <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                            v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { dataInJs } from "@/utils/city.js";
export default {
    name: 'landSearch',
    computed: {
        ...mapState({
            // isCollapse: (state) => state.app.isCollapse,
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            title: "",
            labelWidth: "140px",
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            yj_itemcode: "E02",
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 20, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            enterpristlist: [],
            provinceList: dataInJs(),
            cityList: [],
            countyList: [],
            industryList: [],
            landSearchFilter: {
                province: 44,
                city: '',
                district: '',
                unifiedSocialCreditCode: '',
                establishmentDateMin: '',
                establishmentDateMax: '',
                registeredCapitalMin: '',
                registeredCapitalMax: '',
                actualCapitalMin: '',
                actualCapitalMax: '',
                enterpriseName: '',
                address: '',
                legalRepresentative: '',
                contactPhone: '',
                industry: '',
            },
        }
    },
    created() {
        this.userdata = this.getuseriformation() || {};
    },
    mounted() {
        //只展示广东省
        this.provinceList = this.provinceList.filter(item => item.areaId === 44);
        this.getIndustryList();
        this.onProvinceChange('province', 44);
        this.ajaxsearchcompany();
    },
    methods: {
        getIndustryList() {
            let ajxurl = this.$api.crm.gdEnterprise.industry();
            this.$axios.get(ajxurl).then((res) => {
                if (res.data.success) {
                    console.log("行业", res.data);
                    this.industryList = res.data.list;
                    this.bus.$emit('loading', false);
                } else {
                    //    this.$message.error(res.data.message);
                    this.bus.$emit('loading', false);
                }
            }).catch((error) => {
                this.bus.$emit('loading', false);
            })
        },
        gdEenterpriseDetail(url) {
            const routeUrl = this.$router.resolve({
                path: url,
            })
            window.open(routeUrl.href, '_blank');
        },
        onProvinceChange(target, value) {
            console.log('onProvinceChange', target, value);
            // 清理对应字段
            if (target === 'province') {
                this.cityList = this.provinceList.filter(item => item.areaId === value)[0].children;
                this.landSearchFilter.city = '';
                this.landSearchFilter.county = '';
            } else if (target === 'city') {
                // this.landSearchFilter.city = value;
                this.countyList = this.cityList.filter(item => item.areaId === value)[0].children;
                this.landSearchFilter.county = '';
            } else if (target === 'county') {
                this.landSearchFilter.county = value;
            }
        },
        ajaxsearchcompany(pages) {
            this.page = pages ? pages : 1;
            this.bus.$emit('loading', true);
            let ajxurl = this.$api.crm.gdEnterprise.list();
            let params = {
                page: this.page,
                pageSize: this.pageSize,
                ...this.landSearchFilter
            };
            this.$axios.get(ajxurl, { params: params }).then((res) => {
                if (res.data.success) {
                    console.log("项目列表", res.data);
                    this.enterpristlist = res.data.list;
                    this.totalPage = res.data.totalPage;
                    this.total = res.data.totalRecord;
                    this.pageSize = res.data.pageSize;
                    this.bus.$emit('loading', false);
                } else {
                    //    this.$message.error(res.data.message);
                    this.bus.$emit('loading', false);
                }
            })
        },
        reset() {
            this.landSearchFilter = {
                province: '',
                city: '',
                district: '',
                unifiedSocialCreditCode: '',
                establishmentDateMin: '',
                establishmentDateMax: '',
                registeredCapitalMin: '',
                registeredCapitalMax: '',
                actualCapitalMin: '',
                actualCapitalMax: '',
                enterpriseName: '',
                address: '',
                legalRepresentative: '',
                contactPhone: '',
                industry: '',
            };
            this.ajaxsearchcompany(1);
        },
        pageHandler(page) {
            this.page = page;
            this.ajaxsearchcompany(page);
        },
    },
}
</script>

<style lang="scss" scoped>
.collectfont1 {
    font-size: 14px;
    color: #305ea3;
    cursor: pointer;

    &:hover {
        color: #f19d00;
    }
}

.land_table {
    margin: 0 auto;
    border: 1px solid #f2f2f2;
    background: #fff;
    width: 95%;
    font-size: 14px;

    .title {
        cursor: pointer;
        color: #305ea3;

        &:hover {
            color: #f19d00;
            text-decoration: underline;
        }
    }

    th {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        height: 54px;
        line-height: 54px;
        background: #f2f8fe;
        white-space: nowrap;
        padding: 0 10px;
        border-right: 1px solid #dcdcdc;
    }

    tr {
        height: 40px;
        border-bottom: 1px solid #dcdcdc;

        td {
            text-align: center;
            border-right: 1px solid #dcdcdc;
            padding: 0 10px;
            border-bottom: 1px solid #dcdcdc;
        }
    }
}

::v-deep {
    .el-form-item__label {
        font-weight: 700;
        font-size: 16px;
        color: #333;
    }

    .num-size-input {
        width: 228px;
    }

    .seletc-size-input {
        width: 140px;
    }

    .seletc-size-input-2 {
        width: 220px;
    }

    .seletc-size-input-1 {
        width: 470px;
    }

    .el-input__inner {
        font-size: 14px;
        height: 38px;
    }

    .text-input {
        width: 70%;
    }
}
</style>